// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"589ee5b9","64":"d3acb185","501":"935f303f","508":"4eee2f65","659":"b1fb7a40","923":"09d6d0ff","970":"6a101142"}[chunkId] + ".chunk.css";
};